<template>
  <div class="segmented-control">
    <v-radio-group
      v-model="activeOptionValue"
      class="segmented-control__container pa-1"
      :disabled="disabled"
      hide-details
      required
      inline
    >
      <div v-for="option in options"
        :key="`option-${option.value}`"
        :value="option"
        class="segmented-control__item py-2 px-4 clickable"
        :class="{
          'segmented-control__item--disabled': disabled,
          'segmented-control__item--active': option.value === activeOptionValue,
        }"
        :data-locator="option.locatorValue"
        @click="activeOptionValue = option.value"
      >
        <span class="text-truncated text--small" :class="{'text--bold': option.value === activeOptionValue}">
          {{ option.name }}
        </span>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppSegmentedControl',
  props: {
    activeOption: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      activeOptionValue: this.activeOption,
    }
  },
  watch: {
    activeOptionValue (value) {
      this.$emit('change-active-option', value)
    },
  },
})
</script>

<style lang="scss">
.segmented-control {
  background-color: rgb(var(--v-theme-grey-50));
  border-radius: 8px;
  align-content: center;
  display: flex;

  &__container {
    margin: 0;

    .v-input--radio-group__input {
      display: flex;
      column-gap: 8px;
      justify-content: space-between;
    }

    .v-selection-control-group--inline {
      width:100%;
    }

    .segmented-control__item {
      align-content: center;
      border-radius: 8px;
      color: rgb(var(--v-theme-grey));
      display: flex;
      justify-content: center;
      transition: all .12s ease-in-out;
      flex: 1;

      &--active {
        color: rgb(var(--v-theme-grey-darken-3));
        background-color: rgb(var(--v-theme-white));
      }

      &--disabled {
        cursor: not-allowed;
        color: rgb(var(--v-theme-grey-400));
          background-color: transparent;

        &.segmented-control__item--active {
          color: rgb(var(--v-theme-grey-400));
          background-color: rgb(var(--v-theme-grey-25));
        }
      }
    }
  }
}
</style>
